// Webpack's EnvironmentPlugin/DefinePlugin replaces *literal* `process.env.X`
// references at build time. Computed lookups like process.env[`REACT_APP_${k}`]
// stay as runtime reads, which is undefined in the browser. So each fallback
// must use a literal reference.
const runtime =
  (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

const pick = (runtimeValue, buildValue, fallback = '') => {
  if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
    return runtimeValue;
  }
  if (buildValue !== undefined && buildValue !== null && buildValue !== '') {
    return buildValue;
  }
  return fallback;
};

export const API_URL = pick(runtime.API_URL, process.env.REACT_APP_API_URL);
export const API_URL_POST = pick(runtime.API_URL_POST, process.env.REACT_APP_API_URL_POST);
export const APIM_SUB_KEY = pick(runtime.APIM_SUB_KEY, process.env.REACT_APP_APIM_SUB_KEY);
export const FUNCTION_KEY = pick(runtime.FUNCTION_KEY, process.env.REACT_APP_FUNCTION_KEY);
export const AUTHORITY = pick(runtime.AUTHORITY, process.env.REACT_APP_AUTHORITY);
export const CLIENT_ID = pick(runtime.CLIENT_ID, process.env.REACT_APP_CLIENT_ID);
export const GRAPHME_ENDPOINT = pick(runtime.GRAPHME_ENDPOINT, process.env.REACT_APP_GRAPHME_ENDPOINT);
export const REDIRECT_URI = pick(runtime.REDIRECT_URI, process.env.REACT_APP_REDIRECT_URI);
export const BUILD_ID = pick(runtime.BUILD_ID, process.env.REACT_APP_BUILD_ID, 'dev');
// Fitter Global API base — used for POD regeneration only. Defaults to dev so
// the local CRA can hit it without env config.
export const FITTER_API_URL = pick(
  runtime.FITTER_API_URL,
  process.env.REACT_APP_FITTER_API_URL,
  'https://fitterglobal-dev-api.kindrock-62412995.northeurope.azurecontainerapps.io'
);
